import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Phone, ChevronDown } from "lucide-react";
import Logo from "./Logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about-cochlear-implants", label: "About CI" },
  { to: "/child-cochlear-implant", label: "For Children" },
  { to: "/adult-cochlear-implant", label: "For Adults" },
  { to: "/cochlear-implant-eligibility", label: "Eligibility" },
  { to: "/cochlear-implant-cost-funding", label: "Cost & Funding" },
  { to: "/doctors", label: "Doctor" },
  { to: "/technology", label: "Technology" },
  { to: "/rehabilitation", label: "Rehab" },
  { to: "/patient-stories", label: "Stories" },
  { to: "/news", label: "News" },
  { to: "/csr", label: "CSR" },
  { to: "/knowledge-centre", label: "Knowledge" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200"
    >
      <div className="hc-container">
        {/* Top utility row */}
        <div className="hidden md:flex justify-between items-center py-2 text-sm text-slate-600 border-b border-slate-100">
          <div className="flex items-center gap-4">
            <span className="text-slate-700 font-medium">
              India's Cochlear Implant Knowledge, Access & Rehabilitation Platform
            </span>
            <span className="text-[#0F766E] font-semibold">Powered by HearClear</span>
          </div>
          <div className="flex items-center gap-4">
            <a
              data-testid="header-counsellor-link"
              href="tel:+919000000000"
              className="flex items-center gap-1.5 text-[#0369A1] font-medium hover:text-[#0284C7]"
            >
              <Phone size={16} /> Speak to CI Counsellor
            </a>
          </div>
        </div>

        {/* Main row */}
        <div className="flex items-center justify-between py-3.5">
          <Link
            data-testid="header-logo-link"
            to="/"
            className="group"
          >
            <Logo variant="full" tone="dark" size={42} testId="header-logo" />
          </Link>

          <nav className="hidden xl:flex items-center gap-1">
            {NAV.slice(0, 9).map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
                className={({ isActive }) =>
                  `px-2.5 py-2 text-[14px] font-medium rounded-lg transition-colors ${
                    isActive
                      ? "text-[#0369A1] bg-[#F0F9FF]"
                      : "text-slate-700 hover:text-[#0369A1] hover:bg-slate-50"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <div className="relative group">
              <button className="px-2.5 py-2 text-[14px] font-medium text-slate-700 rounded-lg hover:bg-slate-50 hover:text-[#0369A1] flex items-center gap-1">
                More <ChevronDown size={14} />
              </button>
              <div className="absolute right-0 top-full mt-1 bg-white border border-slate-200 rounded-xl shadow-lg p-2 min-w-[200px] invisible opacity-0 group-hover:visible group-hover:opacity-100 transition">
                {NAV.slice(9).map((n) => (
                  <NavLink
                    key={n.to}
                    to={n.to}
                    data-testid={`nav-more-${n.label.toLowerCase().replace(/ /g, "-")}`}
                    className="block px-3 py-2 text-sm text-slate-700 hover:bg-[#F0F9FF] hover:text-[#0369A1] rounded-lg"
                  >
                    {n.label}
                  </NavLink>
                ))}
              </div>
            </div>
          </nav>

          <div className="flex items-center gap-2">
            <Link
              data-testid="header-eligibility-cta"
              to="/cochlear-implant-eligibility"
              className="hidden sm:inline-flex btn-primary text-sm py-2.5 px-5"
            >
              Check Eligibility
            </Link>
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen(!open)}
              className="xl:hidden p-2 rounded-lg hover:bg-slate-100"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <div data-testid="mobile-nav-menu" className="xl:hidden border-t border-slate-100 py-3">
            <div className="grid grid-cols-2 gap-1">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
                  className={({ isActive }) =>
                    `block px-3 py-2.5 text-[14px] font-medium rounded-lg ${
                      isActive
                        ? "text-[#0369A1] bg-[#F0F9FF]"
                        : "text-slate-700 hover:bg-slate-50"
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              ))}
            </div>
            <Link
              to="/register"
              onClick={() => setOpen(false)}
              data-testid="mobile-register-cta"
              className="btn-primary w-full mt-3 text-sm py-3"
            >
              Register / Get Help
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
